<template>
  <ProgressRoot
    v-bind="delegatedProps"
    :class="cn('relative h-4 w-full overflow-hidden rounded-full bg-muted-foreground', props.class)"
  >
    <ProgressIndicator
      class="h-full w-full flex-1 bg-foreground"
      :style="`transform: translateX(${percentage}%); scaleX(); transition: transform 1s linear`"
    />
  </ProgressRoot>
</template>

<script setup lang="ts">
import { cn } from '@/utils/shadcn';
import { ProgressIndicator, ProgressRoot, type ProgressRootProps } from 'radix-vue';
import { computed, type HTMLAttributes } from 'vue';

const props = withDefaults(defineProps<ProgressRootProps & { class?: HTMLAttributes['class'] }>(), {
  modelValue: 0,
});

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const percentage = ref(-100);

const updatePercentage = () => {
  percentage.value = percentage.value === -100 ? 100 : -100;
};

setInterval(() => {
  updatePercentage();
}, 1000);
</script>
